export const m={
  home:'Home',
  msg:'Information',
  zx:'Message',
  active:'Active',
  searchText:'Search content',
  indexRelease:'Release information',
  more:'Load more',
  moreTips:'No more data',
  indexErrands:'Release errands',
  indexSend:'To publish',
  indexVersion:'Run errands',
  indexAgent:'Purchasing agent',
  indexRequired:'Required',
  indexMyRelease:'My release',
  indexComment:'My evaluation',
  indexShop:'Gift mall',
  indexContact:'Contact service',
  indexFeedback:'Feedback',
  indexPolicy:'Privacy policy',
  indexHelp:'Help center',
  indexLogin:'Login',
  indexReg:'register',
  BackIndex:'Return to home page',
  indexNeeds:'My needs',
  indexMyHome:'My home page',
  indexScore:'My points',
  indexCoins:'My gold coins',
  indexSet:'Account Settings',
  indexOut:'Log out',
  indexPersonal:'Personal authentication',
  indexEnterprise:'Enterprise certification',
  indexAuth:'De authentication',
  indexReviewed:'To be reviewed',
  indexApproved:'Approved',
  indexAudit:'Audit failed',
  Smslogin:'SMS login',
  Pwdlogin:'Password login',
  SmsloginTips:'Unregistered mobile number login will be automatically registered',
  hotPhone:'Hotline',
  loginPhone:'Please enter your mobile phone number',
  loginCode:'Please enter SMS verification code',
  loginStatus:'Remember login status',
  loginForget:'Forget password',
  loginText:'Log in with a registered account',
  inputPwd:'Please input a password',
  otherWay:'Other login methods',
  loginAgreen:'Registration means that I have read and agreed',
  agreenName:'User agreement and privacy policy',
  yzPhone:'Verify mobile number',
  setNewPwd:'Set new password',
  setNewSuccess:'Password reset succeeded',
  setPwdTips:'Please set the 6-20 digit login password',
  setAgainPwd:'Please enter the new login password again',
  setHrefTips:'Automatically jump to login in seconds',
  nextText:'Next step',
  sureText:'Determine',
  wechartTitle:'Wechat code scanning login',
  bindTitle:'Bind mobile phone number',
  submitTitle:'Submit',
  myCollect:'Collection concern',
  myMsg:'My news',
  myRz:'Account authentication',
  collectText:'Collection',
  followText:'Follow',
  scoreText:'Integral',
  coinText:'Gold coins',
  signInText:'Sign in',
  signInOverText:'Signed in',
  allText:'All',
  quotedText:'To be quoted',
  completedText:'To be completed',
  confirmedText:'To be confirmed',
  evaluatedText:'To be evaluated',
  cancelledText:'Cancelled',
  typeText:'Type',
  endTimeText:'Deadline',
  demandText:'Demand details',
  noDataText:'No data',
  lookText:'View details',
  fsText:'Fans',
  editZlText:'Edit data',
  cancelGzText:'Cancel attention',
  editText:'Edit',
  delText:'Delete',
  fbyText:'Published in',
  msgDetailText:'Information details',
  shHomeText:'Merchant home page',
  shDetailText:'Merchant details',
  rzMsgText:'Authentication information',
  zhCommentText:'Comprehensive evaluation',
  contactNumText:'Contact number',
  contactAdrText:'Contact address',
  ytgText:'Merchant authentication passed',
  norzText:'Not certified',
  nothingText:'Nothing',
  shopMsgText:'Store information',
  shopNoMsgText:'No store information',
  BackPrevText:'Back to previous page',
  noCommentText:'No evaluation yet',
  shrzzlText:'Merchant authentication information',
  qyNameText:'Enterprise name',
  frNameText:'Name of legal person',
  yyzzText:'Business license',
  bidInfoText:'Bid winning information',
  runFreeText:'Running expenses',
  remarkMsgText:'Remark information',
  commentRunText:'Evaluate the runner',
  rwSubmitText:'Task submission details',
  sureFinishText:'Confirm completion',
  rwStatusText:'Task status',
  bjListText:'Quotation list',
  seeText:'See',
  noBjText:'Unsuccessful quotation',
  rwTypeText:'Task type',
  rwNameText:'Task name',
  ysMoneyText:'Budget amount',
  sendTimeText:'Release time',
  remidSmText:'Requirement description',
  runNameText:'Name of runner',
  bjbzText:'Quotation remarks',
  operationText:'Operation',
  chooseText:'Choose',
  ptjbText:'Running expenses（gold coins）',
  editShText:'Edit merchant information',
  editShTips:'After submitting the modified merchant information, it will take effect after being approved by the platform',
  bussinessName:'Merchant name:',
  bussinessNameInput:'Please enter merchant name',
  bussinessAddress:'Merchant address：',
  bussinessAddressInput:'Please enter merchant address',
  bussinessPhone:'Merchant telephone：',
  bussinessPhoneInput:'Please enter the merchant phone number',
  bussinessPic:'Graphic introduction：',
  bussinessInput:'Please enter',
  bussinessText:'Entered',
  uploadText:'Upload pictures',
  shareText:'Share to',
  collectedText:'Collected',
  shMessageText:'Merchant information',
  nozwText:'Not yet',
  LookshText:'View merchant home page',
  postCommentText:'Post comments',
  postCommentTips:'Please abide by the comment service agreement when speaking on the Internet in a civilized and rational manner',
  noLogin:'Not logged in',
  noLoginTips:'You can comment after logging in',
  ljLogin:'Log in now',
  expression:'Expression',
  releaseText:'Release',
  allCommentText:'All comments',
  fabulousText:'Fabulous',
  replayText:'Reply',
  stowreplyText:'Stow reply',
  zwPlText:'No comment',
  tjText:'Recommend',
  replyCommentsText:'Reply to comments',
  allZxText:'All information',
  zxDetailText:'Information details',
  hotTjText:'Popular recommendation',
  ybActiveText:'General activities',
  jggActiveText:'Jiugongge lucky draw',
  activeYcyText:'Participated',
  activeYfxText:'Shared',
  activeFwlText:'Visits',
  winningList:'Winning list',
  myPrize:'My prize',
  myPrizeText:'Yes',
  activeInfo:'Activity introduction',
  activeAllInfo:'All activities',
  activeDzp:'Turntable lottery',
  oneText:'The first prize',
  twoText:'Second award',
  threeText:'Third award',
  selectText:'Selection activities',
  totalVotesText:'Total Votes',
  sjNumText:'Number of merchants',
  numberVoteText:'Number',
  tpVoteText:'Vote',
  pVoteText:'ticket',
  dlqText:'Unclaimed',
  ywcText:'Completed',
  editBussinessTips:'Merchant data change is under review, please wait patiently.',
  editBussinessTipsSuccess:'Merchant data has been approved.',
  reSubmitTips:'Resubmit',
  help:'Help center classification',
  zdTitle:'Zhongda textile city',
  zdTips:'Personalized recommendation, convenient switching and enjoy wonderful information at your heart',
  zdBanTitle:'edition',
  locationChoose:'Select by province',
  locationChooseInput:'Please select a province',
  locationSearch:'Direct search',
  locationSearchText:'Search',
  locationLetter:'Select by phonetic alphabet',
  rzType:'Certification Type',
  qyNameInput:'Please enter enterprise name',
  qyPicTips:'Please upload clear photos of business license for certification only!',
  rzRole:'Authentication role',
  rzRoleLegal:'Legal person',
  rzRoleContact:'Contacts',
  rzFrInput:'Please enter your name',
  rzContactWay:'Contact information',
  rzContactInput:'Please enter your contact information',
  frSfzText:'Corporate ID card',
  sfzRzText:'Please upload clear front and back photos of ID card for authentication only!',
  ContactNameText:'Contact name',
  ContactNameInput:'Please enter contact name',
  Contactsfz:'Contact ID card',
  applyText:'Application letter',
  applyTips:'Please upload a clear photo of the application letter (with fresh seal) for certification only',
  applyDown:'Download application letter template',
  ResetText:'Reset',
  waitText:'The data has been submitted successfully and is being reviewed. Please wait patiently',
  waitTips:'The audit has passed. Thank you for your support. Here is your certification information',
  changeContact:'Change contact',
  coinRule:'Gold coin rule',
  coinRuleNow:'Current gold coins',
  changeTime:'Change time',
  changeType:'Revenue and expenditure type',
  changeOut:'Expenditure',
  changeEnter:'Income',
  changeTypeBd:'Change type',
  coinChange:'Gold coin change',
  cancelCollect:'Cancel collection',
  runScore:'Score',
  runComment:'Evaluation content',
  commentMy:'Evaluate my',
  Mycomment:'I think so',
  Myapply:'My reply',
  sjReply:'Merchant reply',
  feedType:'Feedback type:',
  chooseTextTips:'Please select',
  opinionText:'Your opinion:',
  opinionSuccess:'Comments submitted successfully',
  opinionTips:'Thank you for your feedback and support',
  systemText:'System message',
  quotation:'Quotation feedback',
  zbfkText:'Bid winning feedback',
  payText:'Payment',
  runHomeText:'Runner Homepage',
  levelText:'Level',
  enterPtText:'Settled platform',
  serviceNumText:'Number of customers served',
  DetailJsText:'Details',
  noJsText:'No introduction',
  scoreRuleText:'Integral rule',
  scoreRuleTips:'The current points will be cleared as your membership expires. Please renew your membership in time!',
  closeTips:'Close prompt',
  nowScoreTips:'Current integral',
  Redeempoints:'Redeem points',
  Integralchange:'Integral change',
  Datasetting:'Data setting',
  Accountsecurity:'Account security',
  Accountpassword:'Account password',
  AccountTips:'It is recommended that you change your password regularly. Setting a password with high security can make your account more secure',
  AccountEdit:'Modify',
  Accountphone:'Account phone',
  AccountphoneTips:'Account phone can be used for login, password reset or other security verification',
  Bindingwechat:'Binding wechat',
  Bound:'Bound',
  Unbound:'Unbound',
  BindTips:'Bind wechat account and log in easily with wechat account',
  Boundjb:'Unbound',
  Boundbd:'binding',
  headPortrait:'Head portrait',
  headEdit:'Modify Avatar',
  nickname:'Nickname',
  nicknameTips:'Enter nickname',
  cityText:'City',
  cityTextInput:'Please select your city',
  saveText:'Save',
  editMoblieText:'Modify mobile phone number',
  AuthenticationText:'Authentication information',
  AutheNewNumText:'Verify new number',
  AuthFinshText:'Complete number change',
  identityText:'To confirm your identity, we need to verify your mobile phone account',
  identityTextTips:'If your current mobile phone number is no longer available, please contact customer service',
  nowMobileText:'Current account mobile phone',
  newPhoneInput:'Please enter a new phone number',
  phoneSuccess:'Congratulations! Mobile phone number modified successfully',
  phoneSuccessTips:'Please log in with your new mobile number next time',
  modifyPwd:'Modify login password',
  oldPwd:'Old Password:',
  oldPwdInput:'Please enter the original password',
  newPwd:'New password:',
  newPwdInput:'Please enter a new password',
  surePwdInput:'Confirm password:',
  surePwdInputTips:'Please enter the password again in the',
  pwdTips:'The password is 6 ~ 20 digits long, and at least two types of numbers, letters and characters are included',
  cancelTips:'Cancel',
  signTips:'Continuous check-in can get more points~',
  signTipsText:'Continuous check-in',
  dayText:'day',
  ljSignText:'Sign in now',
  mustText:'Is required',
  categoryText:'Information category:',
  categorySecondText:'Secondary category:',
  methodText:'Typesetting method:',
  infoTitleText:'Message header:',
  infocontentText:'information content:',
  picWayText:'Graphic mode:',
  picUpText:'Picture on',
  fontUpText:'Text on',
  positionText:'Position:',
  moneyText:'amount of money:',
  readText:'Read and agree',
  agreementText:'Release agreement',
  shareSendtText:'Share release',
  DirectText:'Direct release',
  wxTipsText:"Warm tip: if you don't have enough points, you can click share to publish the shared content and earn points~",
  rwsendTypeText:'Task type:',
  ysMoneySendText:'Budget amount:',
  ysMoneySendInput:'Please enter budget amount',
  endTimeSendText:'Deadline:',
  chooseDateText:'Please select a date',
  sendXqsmText:'Requirements Description:',
  hotSearchText:'Popular search',
  searchHistoryText:'Search history',
  clearHistoryText:'Clear history',
  noHistoryText:'No history',
  addAddressText:'New address',
  editAddressText:'Modify address',
  ConsigneeName:'Consignee Name:',
  ConsigneeNameInput:'Please enter the name of the consignee',
  Consigneemobile :'Consignee mobile number:',
  ConsigneemobileInput:'Please enter the mobile phone number of the consignee',
  LocationText:'Location:',
  Detailedaddress:'Detailed address:',
  DetailedaddressInput:'Please enter the detailed address',
  defaultdaddress:'Set as default address:',
  addressList:'Address list',
  defaultText:'Default',
  giftText:'Gift details',
  SupportText:'Support distribution',
  SelfText:'Self mention',
  DescriptionText:'Description text',
  GiftInfoText:'Gift introduction',
  GiftExchangeText:'Gift exchange',
  Receiving:'Receiving information',
  ReceivingWay:'Receiving method:',
  mailText:'mail',
  selfChooseText:'Self mention',
  Receivingaddress:'Receiving address:',
  selfaddress:'Pick up address:',
  chooseaddress:'Select address',
  MailFreight:'Mail freight',
  selfTime:'Self lifting time',
  giftMsg:'Gift information',
  UnitPrice:'Unit price',
  quantity:'Quantity',
  Subtotal:'Subtotal',
  exchangeInfo:'Exchange information',
  Required:'Required points',
  AccountText:'Account available points',
  Exchangerecord:'Exchange record',
  LogisticsText:'Logistics information',
  noLogisticsText:'No logistics information',
  exchangeTime:'Exchange time',
  exchangeNumber:'Exchange quantity',
  exchangeDetail:'Exchange details',
  exOneTips:'If the gift is redeemed successfully, we will express it to your mailing address',
  exTwoTips:'Gift exchange succeeded! Please go to the pick-up point to collect gifts',
  exThreeTips:'The gift has been collected. Thank you for your use!',
  WriteCode:'Write off code',
  Mailingstatus:'Mailing status',
  ViewLogistics:'View logistics',
  Requiredgold:'Required gold coins',
  Extractiontime:'Extraction time',
  Completiontime:'Completion time',
  downloadClick:'Click to download the attachment',
  wechartSao:'Scan wechat and share with friends',

  outTime:'Expiration time',

  pushTitle: 'Push Message',
  recommendGoods: 'Recommended Commodities',
  recommendNews: 'Recommended information',
  recommendStore: 'Recommended merchants',
  recommendNotice: 'System notification',
  notPrompting: "Don't prompt again",
  store: 'Business',
  onlineContact: 'Online contact',
  storeHome: 'Merchant homepage',

  pickingUpAddress: 'Picking address：',
  receiptAddress: 'Ship To Address：',
  userGrade: 'Runner level：',
  userGradeTips: 'If you change the service price of the runner level, please click here to change it before publishing',
  placeholderName: 'Please enter name',
  placeholderMobile: 'Please enter phone number',
  placeholderAddress: 'Please enter the detailed address',
  number: 'Quantity：',
  placeholderNumber: 'Please enter the quantity',
  placeholderUnit: 'Please select a unit',
  kilograms: 'Kilograms：',
  submitTipsBefore: 'This release needs to be deducted',
  submitTipsAfter: 'Gold coin',

  placeholderContent: 'Please enter the content',
  sendBtn: 'Send Out',
  overdue: 'The authentication of the merchant has expired, and communication cannot continue',
  deleteDialogue: 'delete',
  messageCenter: 'Message Center',
  releaseMine: 'Publish by yourself',
	releaseStore: 'Publish by merchants',
  myOrder: 'My order',
  placeholderInfo: 'Please select the message to send',
  infoTitle: 'Send Message',

  cooperTitle: 'Business cooperation',
  cooperMobile: 'Contact number',
  cooperWxName: 'Wechat number',
  cooperEmail: 'Mailbox',
  cooperOther: 'Other contact information',
  cooperContent: 'Business cooperation demand',
  cooperContentTips: 'Please enter the business cooperation demand',
  cooperSuccess: 'Submitted successfully',
  cooperSuccessTips: 'Thank you for your trust and support. A staff member will contact you later. Please wait patiently',

  frozenDetail: 'Freeze Details',
  frozenNotTips: 'Your account has been frozen',
  frozenNotDesc: 'Cannot publish content and participate in activities',
  frozenTips: 'Your account has been unsealed',
  frozenDesc: 'You can continue to publish content and participate in activities',
  frozenTime: 'Freezing time：',
  frozenReason: 'Reason for freezing：',
  frozenApply: 'Unsealing application：',
  frozenApplyTips: 'Your application for unsealing has been submitted, please wait for the staff to review',
  frozenResult: 'Processing results：',
  frozenSupplement: 'Information supplement：',
  frozenSupplementTips: 'Your information supplement has been submitted, please wait for the staff to review',
  frozenApplyUnblock: 'Apply for unsealing',
  frozenApplyAgain: 'Re apply',
  frozenSupplementInfo: 'Supplementary information',
  frozenTextDescribe: 'Text description：',
  frozenDescPlaceholder: 'Please enter the relevant text description',
  frozenUpload: 'Upload pictures：',

	// 2024-07-16 新增
  confirmOrder: 'Confirm an order',
  confirmOrderSub: 'Please pay within 10 minutes',
  consignee: 'Consignee',
  commodityInformation: 'Commodity information',
  producName: 'Product name',
  modeOfPayment: 'Mode of payment',
  payByAlipay: 'Pay by Alipay',
  WeChatPay: 'WeChat Pay',
  GoldCoinPayment: 'Gold coin payment',
  keYong: 'available',
  yuan: 'Yuan',
  totalPrices: 'total prices:',
  AmountToBePaid: 'Amount to be paid:',
  payTips: 'Please select a payment method',
  topUp: 'Top up',
  GoldCoinRecharge: 'Gold coin recharge',
  GoldCoinRechargeAmount: 'Gold coin recharge amount',
  sellingPrice: 'selling price',
  amountPayable: 'Amount payable: ',
  goldPayTips: 'Please select the recharge amount',
  reminder: 'Reminder',
	Completedpayment: 'Completed payment',
	zfts_tips: 'You are paying outside the website, please return to the current page to confirm the payment',
	PurchaseRecord: "Purchase record",
	timeBuying: "Time buying",
	paymentAmount: "Payment amount",
	purchaseQuantity: "purchase quantity",
	commodityDetails: "commodity details",
  exOneTipsNew:'Successful purchase, we will express it to your mailing address',
  exTwoTipsNew:'Successful purchase! Please go to the pick-up point to cancel the pick-up goods',
  exThreeTipsNew:'The goods have been extracted, thank you for your use！',
	merchandiseNews: 'Merchandise News',
  year:'Year',
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js